import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_EDIT,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../../../Entity'

import DeleteIcon from '../../../../../icons/delete.svg'

export const QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_CELL =
  'applicantProfileFollowUpCell'

export const QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_INPUT =
  'applicantProfileFollowUpInput'

export const QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_DELETE =
  'applicantProfileFollowUpDeleteBtn'

export const APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_DELETE = 'delete'

export const APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_ADD =
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD

export const APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_EDIT =
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT

export const APPLICANT_PROFILE_FOLLOW_UP_ACTIONS = [
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_EDIT,
  {
    Button: Button.Outlined,
    key: APPLICANT_PROFILE_FOLLOW_UP_ACTION_KEY_DELETE,
    props: {
      beforeIconProps: { Icon: DeleteIcon },
      height: BUTTON_HEIGHT_32,
      qaName: QA_NAME_APPLICANT_PROFILE_FOLLOW_UP_DELETE,
      tooltip: 'Modal.DeleteBtnKey',
    },
    show: contentExist => contentExist,
  },
]
